import React from "react";
import { styled } from "@mui/material/styles";
import Colors from "../../../../theme/tokens/colors";

const Icon = styled("i")`
  width: ${(props) =>
    props.width ? props.width + "px !important" : "24px !important"};
  height: ${(props) =>
    props.height ? props.height + "px !important" : "24px !important"};
  color: ${(props) => (props.color ? props.color : Colors.BASE_GREY_200)};
`;

export default function FontAwesomeIcon({ name, color, width, height }) {
  return (
    <Icon color={color} width={width} height={height} className={name}></Icon>
  );
}
